import React, { Component } from 'react'
import { Field } from 'redux-form/immutable'
import Popover from 'react-popover'
import cn from 'classnames'

import Button from 'app/components/ButtonDefault'
import TextArea from 'app/components/TextArea'
import InfoPopover from 'app/components/InfoPopover'

import './styles.scss'

const bc = 'user-story-form'

class UserStoryForm extends Component {
  state = {
    showUsersTooltip: false,
  }

  render() {
    const {
      t,
      handleSubmit,
      pristine,
      submitting,
      question,
      showTooltip,
      setFeatureAsShown,
      valid,
      className,
      title,
    } = this.props
    return (
      <form onSubmit={handleSubmit} className={cn(bc, { [className]: !!className })}>
        {title && (
          <div className={`${bc}__title`} style={{ marginRight: '8px' }}>
            {t('Please share a story about your previous action.')}
          </div>
        )}
        <div className={`${bc}__title`}>{question}</div>
        <div className={`${bc}__feilds`}>
          <Field
            name="story"
            component={TextArea}
            className={`${bc}__input-wrapper`}
            classTextArea={`${bc}__input`}
            classNumberOfLetters={`${bc}__counter`}
            placeholder={t('Please write here')}
            maxCharacters={400}
            availableMentionOptions
          />
          <Button type="submit" primary className={`${bc}__button`} disabled={pristine || submitting || !valid}>
            {t('Share')}
          </Button>
        </div>
        <div className={`${bc}__message`}>{t('You can to tag someone in the story using “@“ before name')}</div>
        <Popover
          isOpen={showTooltip}
          preferPlace="below"
          place={null}
          tipSize={7}
          body={
            <InfoPopover
              className={`${bc}__popup`}
              title={t('new-feauture-stories')}
              text={t(`Stories are powerful tools`)}
              action={() => setFeatureAsShown({ stories: false })}
            />
          }
        >
          <div className={`${bc}__target`} />
        </Popover>
      </form>
    )
  }
}

export default UserStoryForm
